<template>
  <a
    class="ss__desktop__menu__post__item"
    :href="item.url"
    :target="item.blank ? '_blank' : '_self'">
    <img
      :src="$formatImageSrc(item.image, { w: 360, h: 230 }) || $app.imgErrorSrc"
      :alt="item.name"
      class="ss__desktop__menu__post__item__image"
    />
    <div class="ss__desktop__menu__post__item__type">{{ item.type }}</div>
    <div class="ss__desktop__menu__post__item__title">{{ item.name }}</div>
  </a>
</template>

<script>
export default {
  name: 'SsDesktopMenuPostItem',

  props: {
    item: Object
  }
}
</script>

<style lang="stylus" scoped>
.ss__desktop__menu__post__item {
  .ss__desktop__menu__post__item__image {
    width: var(--w-SsDesktopMenuPostItemImage, 180px);
    height: var(--h-SsDesktopMenuPostItemImage, 115px);
    border-radius: var(--radius-SsDesktopMenuPostItemImage, 8px);
    border: var(--border-SsDesktopMenuPostItemImage, (1px solid rgba(0, 0, 0, 0.05)));
    margin: var(--margin-SsDesktopMenuPostItemImage, (0px 0px 8px));
    object-fit: cover;
    box-sizing: border-box;
  }

  .ss__desktop__menu__post__item__type {
    font-size: var(--text-SsDesktopMenuPostItemType, 13px);
    color: var(--color-SsDesktopMenuPostItemType, var(--B6-t));
    font-weight: var(--weight-SsDesktopMenuPostItemType, 500);
  }

  .ss__desktop__menu__post__item__title {
    width: var(--h-SsDesktopMenuPostItemtitle, 180px);
    font-size: var(--text-SsDesktopMenuPostItemTitle, 13px);
    color: var(--color-SsDesktopMenuPostItemTitle, var(--B8-t));
    font-weight: var(--weight-SsDesktopMenuPostItemTitle, 400);
    margin: var(--margin-SsDesktopMenuPostItemTitle, (4px 0px 0px));
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
}
</style>
